import { getRoomTypes } from '../../utils/hotels';
import { createReducer } from './create';

function filterHotels(
    hotels,
    numberOfGuests,
    selectedNights,
    selectedRange,
    roomType,
) {
    const result = {
        available: [],
        unavailable: [],
    };

    const rooms = getRoomTypes(numberOfGuests, roomType);
    const totalNumberOfRooms = rooms.reduce((carry, r) => carry + r.count, 0);

    const unevenNumberOfGuests = numberOfGuests % 2 !== 0;

    for (let i = 0, l = hotels.length, hotel, range; i < l; ++i) {
        hotel = hotels[i];
        range = hotel.ranges[selectedNights][selectedRange];

        let available = range.available && range.stock
            .every(s => s >= totalNumberOfRooms);

        if (roomType === 0 && unevenNumberOfGuests) {
            available =
                range.available_s &&
                range.stock.every(s => s >= totalNumberOfRooms);
        }

        if (roomType === 1 && unevenNumberOfGuests) {
            available =
                range.available_t &&
                range.stock.every(s => s >= totalNumberOfRooms);
        }

        if (available) {
            result.available.push(hotel);
        } else {
            result.unavailable.push(hotel);
        }
    }

    result.available = sortHotelsByPrice(
        result.available,
        selectedNights,
        selectedRange,
    );

    result.unavailable = sortHotelsByPrice(
        result.unavailable,
        selectedNights,
        selectedRange,
    );

    return result;
}

function reconcileSelectedHotel(
    availableHotels,
    selectedHotel,
    userSelectedHotel,
) {
    if (!availableHotels || selectedHotel == null) {
        return null;
    }

    if (userSelectedHotel != null) {
        for (let i = 0, l = availableHotels.length; i < l; ++i) {
            if (availableHotels[i].id === userSelectedHotel.id) {
                return availableHotels[i];
            }
        }
    }

    for (let i = 0, l = availableHotels.length; i < l; ++i) {
        if (availableHotels[i].id === selectedHotel.id) {
            return availableHotels[i];
        }
    }
}

function sortHotelsByPrice(hotels, nights, range) {
    const copy = hotels.slice();
    copy.sort(function(a, b) {
        let price_type = 'price';

        const aPrice = a.ranges[nights][range][price_type];
        const bPrice = b.ranges[nights][range][price_type];

        if (aPrice < bPrice) {
            return -1;
        } else if (bPrice < aPrice) {
            return 1;
        }

        return 0;
    });

    return copy;
}

function getCheapestHotelConfigurationFromHotels(hotels, nights = null) {
    let cheapestConfiguration = null;
    for (let i = 0, configuration; i < hotels.length; ++i) {
        configuration = getCheapestHotelConfiguration(hotels[i], nights);

        if (
            configuration != null &&
            (
                cheapestConfiguration == null ||
                configuration.price < cheapestConfiguration.price
            )
        ) {
            cheapestConfiguration = {
                hotel: hotels[i],
                ...configuration,
            };
        }
    }

    return cheapestConfiguration;
}

function getCheapestHotelConfiguration(hotel, nights = null) {
    let cheapestConfiguration = null;

    if (nights == null) {
        for (
            let i = 0,
                l = hotel.ranges.length,
                range;
            i < l;
            ++i
        ) {
            if (hotel.ranges[i] == null) {
                continue;
            }

            range = getCheapestHotelRangeFromRanges(hotel.ranges[i]);

            if (
                range != null &&
                (
                    cheapestConfiguration == null ||
                    range.price < cheapestConfiguration.price
                )
            ) {
                cheapestConfiguration = {
                    nights: i,
                    ...range,
                };
            }
        }
    } else if (hotel.ranges[nights] != null) {
        const range = getCheapestHotelRangeFromRanges(
            hotel.ranges[nights],
        );

        if (range) {
            cheapestConfiguration = {
                nights,
                ...range,
            };
        }
    }

    return cheapestConfiguration;
}

function getCheapestHotelRangeFromRanges(ranges) {
    let cheapestRange = null;
    if (ranges != null) {
        for (let i = 0, l = ranges.length, range; i < l; ++i) {
            range = ranges[i];

            if (range.stock === 0 || !range.available) {
                continue;
            }

            if (cheapestRange == null || range.price < cheapestRange.price) {
                cheapestRange = {
                    range: i,
                    price: range.price,
                };
            }
        }
    }

    return cheapestRange;
}

const initialState = {
    optional: window['NOJESRESOR_PRODUCT'] != null
        ? NOJESRESOR_PRODUCT.hotels.optional
        : false,
    without: window['NOJESRESOR_PRODUCT'] != null
        ? NOJESRESOR_PRODUCT.hotels.without
        : false,
    is_loading_hotels: false,
    has_loaded_hotels: false,
    number_of_guests: 0,
    event_days: [],
    confirmed_ticket_nights: null,
    available_nights: [],
    available_days: [],
    unfiltered_hotels: [],
    included_hotel: null,
    available_hotels: [],
    unavailable_hotels: [],
    selected_hotel: null,
    user_selected_hotel: null,
    selected_hotel_nights: 0,
    selected_hotel_range: 0,
    confirmed_hotel: null,
    confirmed_hotel_range: null,
    selected_hotel_roomtype: 0,
    step_hotel_done: false,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: () => {
        return initialState;
    },
    ['HOTELS/LOAD']: (state) => {
        return Object.assign({}, state, {
            is_loading_hotels: true,
        });
    },
    ['TICKETS/CONFIRM']: (state, payload) => {
        const event_days = [];
        const first_ticket = payload.confirmed_tickets[0];
        for (let i = 0, l = first_ticket.all_dates.length; i < l; ++i) {
            event_days.push(new Date(first_ticket.all_dates[i]).getDay());
        }

        const count = payload.confirmed_tickets.length;
        const hotel_included_id = payload.confirmed_package.hotel
            ? payload.confirmed_package.hotel.product_id
            : null;

        return Object.assign({}, state, {
            hotel_included_id: hotel_included_id,
            number_of_guests: count,
            event_days: event_days,
            confirmed_ticket_nights: payload.confirmed_tickets[0].all_dates.length -
                1,
        });
    },
    ['HOTELS/LOAD_FINISHED']: (state, payload) => {
        let {
            hotel: cheapestHotel,
            nights: selectedNights,
            range: selectedRange,
        } = getCheapestHotelConfigurationFromHotels(payload.items);

        const range = cheapestHotel.ranges;

        const availableNights = [];
        for (let i = 0, l = range.length; i < l; ++i) {
            if (range[i] == null) {
                continue;
            }

            availableNights.push(i + 1);
        }

        const availableDays = [];
        for (let i = 0, l = range[selectedNights].length; i < l; ++i) {
            availableDays.push({
                from: range[selectedNights][i].from,
                to: range[selectedNights][i].to,
            });
        }

        let includedHotel = null;
        for (let i = 0; i < payload.items.length; i++) {
            let hotel = payload.items[i];
            if (hotel.id === state.hotel_included_id) {
                includedHotel = hotel;
                break;
            }
        }

        let selectedHotelRoomType =
            state.number_of_guests % 2 !== 0 && state.number_of_guests > 2
                ? 1
                : 0;

        let hotels = filterHotels(
            payload.items,
            state.number_of_guests,
            selectedNights,
            selectedRange,
            selectedHotelRoomType,
        );

        // If there are no available hotels, and we're looking for hotels which
        // offer triple rooms, check if there are double rooms which can
        // accommodate the visitors instead.
        if (selectedHotelRoomType === 1 && hotels.available.length === 0) {
            const doubleRoomHotels = filterHotels(
                payload.items,
                state.number_of_guests,
                selectedNights,
                selectedRange,
                0,
            );

            if (doubleRoomHotels.available.length > 0) {
                selectedHotelRoomType = 0;
                hotels = doubleRoomHotels;
            }
        }

        for (let i = 0; i < hotels.available.length; i++) {
            let hotel = hotels.available[i];
            if (hotel.id === state.hotel_included_id) {
                includedHotel = null;
                break;
            }
        }

        return Object.assign({}, state, {
            included_hotel: includedHotel,
            is_loading_hotels: false,
            has_loaded_hotels: true,
            available_nights: availableNights,
            available_days: availableDays,
            unfiltered_hotels: payload.items,
            available_hotels: hotels.available,
            unavailable_hotels: hotels.unavailable,
            selected_hotel_nights: selectedNights,
            selected_hotel_range: selectedRange,
            selected_hotel_roomtype: selectedHotelRoomType,
            selected_hotel: null,
        });
    },
    ['HOTELS/SELECT']: (state, payload) => {
        return Object.assign({}, state, {
            selected_hotel: payload,
            user_selected_hotel: payload,
            confirmed_hotel: null,
            confirmed_hotel_range: null,
        });
    },
    ['HOTELS/SELECT_ROOM_TYPE']: (state, payload) => {
        const roomType = parseInt(payload, 10);
        const hotels = filterHotels(
            state.unfiltered_hotels,
            state.number_of_guests,
            state.selected_hotel_nights || 0,
            state.selected_hotel_range || 0,
            roomType,
        );

        const selectedHotel = reconcileSelectedHotel(
            hotels.available,
            state.selected_hotel,
            state.user_selected_hotel,
        );

        let included_hotel = null;
        for (var i = 0; i < state.unfiltered_hotels.length; i++) {
            let hotel = state.unfiltered_hotels[i];
            if (hotel.id === state.hotel_included_id) {
                included_hotel = hotel;
                break;
            }
        }

        for (var i = 0; i < hotels.available.length; i++) {
            let hotel = hotels.available[i];
            if (hotel.id === state.hotel_included_id) {
                included_hotel = null;
                break;
            }
        }

        return Object.assign({}, state, {
            included_hotel: included_hotel,
            selected_hotel: selectedHotel,
            available_hotels: hotels.available,
            unavailable_hotels: hotels.unavailable,
            selected_hotel_roomtype: roomType,
        });
    },
    ['HOTELS/SELECT_NIGHTS']: (state, payload) => {
        const {
            range: selectedRange,
        } = getCheapestHotelConfigurationFromHotels(
            state.unfiltered_hotels,
            payload,
        );

        const hotels = filterHotels(
            state.unfiltered_hotels,
            state.number_of_guests,
            payload,
            selectedRange,
            state.selected_hotel_roomtype || 0,
        );

        const selectedHotel = reconcileSelectedHotel(
            hotels.available,
            state.selected_hotel,
            state.user_selected_hotel,
        );

        const availableDays = [];
        for (
            let i = 0,
                l = state.unfiltered_hotels[0].ranges[payload].length;
            i < l;
            ++i
        ) {
            availableDays.push({
                from: state.unfiltered_hotels[0].ranges[payload][i].from,
                to: state.unfiltered_hotels[0].ranges[payload][i].to,
            });
        }

        let includedHotel = null;
        for (let i = 0; i < state.unfiltered_hotels.length; i++) {
            let hotel = state.unfiltered_hotels[i];
            if (hotel.id === state.hotel_included_id) {
                includedHotel = hotel;
                break;
            }
        }

        for (let i = 0; i < hotels.available.length; i++) {
            let hotel = hotels.available[i];
            if (hotel.id === state.hotel_included_id) {
                includedHotel = null;
                break;
            }
        }

        return Object.assign({}, state, {
            included_hotel: includedHotel,
            available_days: availableDays,
            selected_hotel: selectedHotel,
            available_hotels: hotels.available,
            unavailable_hotels: hotels.unavailable,
            selected_hotel_nights: payload,
            selected_hotel_range: selectedRange,
        });
    },
    ['HOTELS/SELECT_RANGE']: (state, payload) => {
        const hotels = filterHotels(
            state.unfiltered_hotels,
            state.number_of_guests,
            state.selected_hotel_nights,
            payload,
            state.selected_hotel_roomtype || 0,
        );

        const selectedHotel = reconcileSelectedHotel(
            hotels.available,
            state.selected_hotel,
            state.user_selected_hotel,
        );

        let included_hotel = null;
        for (let i = 0; i < state.unfiltered_hotels.length; i++) {
            let hotel = state.unfiltered_hotels[i];
            if (hotel.id === state.hotel_included_id) {
                included_hotel = hotel;
                break;
            }
        }

        for (let i = 0; i < hotels.available.length; i++) {
            let hotel = hotels.available[i];
            if (hotel.id === state.hotel_included_id) {
                included_hotel = null;
                break;
            }
        }

        return Object.assign({}, state, {
            included_hotel: included_hotel,
            selected_hotel: selectedHotel,
            available_hotels: hotels.available,
            unavailable_hotels: hotels.unavailable,
            selected_hotel_range: payload,
        });
    },
    ['HOTELS/DESELECT']: state => {
        return Object.assign({}, state, {
            selected_hotel: null,
            confirmed_hotel: null,
            confirmed_hotel_range: null,
            step_hotel_done: false,
        });
    },
    ['HOTELS/NOHOTEL']: (state) => {
        return Object.assign({}, state, {
            is_loading_hotels: false,
            has_loaded_hotels: false,
            available_nights: [],
            available_days: [],
            unfiltered_hotels: [],
            available_hotels: [],
            unavailable_hotels: [],
            selected_hotel: null,
            user_selected_hotel: null,
            selected_hotel_nights: 0,
            selected_hotel_range: 0,
            confirmed_hotel: null,
            confirmed_hotel_range: null,
            step_hotel_done: false,
        });
    },
    ['HOTELS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            step_hotel_done: true,
            confirmed_hotel: payload.confirmed_hotel,
            confirmed_hotel_range: payload.confirmed_hotel_range,
        });
    },
});
